export const BASIC_IMAGE_GQL = `
  data {
    attributes {
      formats
      url
    }
  }
`;
